import { CircularProgress } from "@material-ui/core"
import React, { FunctionComponent, useEffect } from "react"
import { Route, Redirect } from "react-router"
import { useAuth } from "./common/hooks/useAuth"

export interface AuthRouteProps {
    path: string
    component: React.ComponentType
}

export const AuthRoute: FunctionComponent<AuthRouteProps> = ({ path, component }) => {
    const { authenticated, currentUser, loadCurrentUser, loadingCurrentUser } = useAuth()

    useEffect(() => {
        if (!currentUser && !loadingCurrentUser) {
            loadCurrentUser()
        }
    }, [currentUser, loadingCurrentUser, loadCurrentUser])

    if (authenticated === undefined || loadingCurrentUser) {
        return <CircularProgress />
    }
    if (authenticated) {
        return <Route component={component} />
    }
    return <Redirect push to={{ pathname: "/login" }} />
}
